<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <v-btn
    :classd="getClasses"
    :color="color"
    :outlined="outlined"
    :retain-focus-on-click="retainFocusOnClick"
    :tile="tile"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: 'BaseBtn',
  props: {
    color: {
      type: String,
      default: () => 'accent'
    },
    retainFocusOnClick: {
      type: Boolean,
      default: () => !1
    },
    minWidth: {
      type: [String, Number],
      default: () => undefined
    },
    tile: {
      type: Boolean,
      default: () => !1
    },
    outlined: {
      type: Boolean,
      default: () => !1
    }
  },
  computed: {
    getClasses () {
      // console.log(this.$attrs.class)
      const classes = [
        'app-btn',
        'my-1'
        // 'ms-1',
      ]
      // console.log(this.$props)
      // if (this.$el && this.$el.getAttribute('class')) {
      //   classes.push(this.$el.getAttribute('class'))
      // console.log();
      // }
      return classes.join(' ')
    }
  }
}
</script>
